var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:image-secure"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.3333 26.6667V24.1667C36.3333 21.8333 34 20 31.6667 20C29.3333 20 27 21.8333 27 24.1667V26.6667C26 26.6667 25 27.6667 25 28.6667V34.5C25 35.6667 26 36.6667 27 36.6667H36.1667C37.3333 36.6667 38.3333 35.6667 38.3333 34.6667V28.8333C38.3333 27.6667 37.3333 26.6667 36.3333 26.6667ZM34.1667 26.6667H29.1667V24.1667C29.1667 22.8333 30.3333 22 31.6667 22C33 22 34.1667 22.8333 34.1667 24.1667V26.6667ZM8.33333 5C6.5 5 5 6.5 5 8.33333V31.6667C5 32.5507 5.35119 33.3986 5.97631 34.0237C6.60143 34.6488 7.44928 35 8.33333 35H21.7167C21.6667 34.8333 21.6667 34.6667 21.6667 34.5V30H8.33333L14.1667 22.5L18.3333 27.5L24.1667 20L24.6167 20.6167C26.0167 18.15 28.7833 16.6667 31.6667 16.6667C32.8167 16.6667 33.95 16.9333 35 17.3667V8.33333C35 7.44928 34.6488 6.60143 34.0237 5.97631C33.3986 5.35119 32.5507 5 31.6667 5H8.33333Z",
    fill: "#076AFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLock);
export default __webpack_public_path__ + "static/media/image-lock.f284f65550db27783be7fa6ddb295f39.svg";
export { ForwardRef as ReactComponent };